var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { DEFAULT_THEME } from './default';
export var LAB_THEME = __assign(__assign({}, DEFAULT_THEME), {
  color: __assign(__assign({}, DEFAULT_THEME.color), {
    primary: '#7674C0',
    secondary: '#D2B400',
    primaryDarker: '#474673',
    primaryLight: '#928ECD',
    primaryLighter: '#BCB7DF',
    primaryBright: '#7674C0',
    primaryVeryLight: '#D9D4EC',
    link: '#7674C0',
    linkHover: '#000000',
    linkInverted: '#FFFFFF',
    linkInvertedHover: '#7674C0',
    navigationActive: '#D2B400'
  })
});
LAB_THEME.color.accentLight = LAB_THEME.color.primaryLight;
LAB_THEME.color.accentDark = LAB_THEME.color.primaryDarker;
export default LAB_THEME;